document.addEventListener('DOMContentLoaded', function () {
  const collapsibles = document.querySelectorAll('.custom-collapsible');

  collapsibles.forEach(button => {
    button.addEventListener('click', function () {
      const content = this.nextElementSibling;
      const icon = this.querySelector('.collapsible-icon');

      content.classList.toggle('active');

      if (content.classList.contains('active')) {
        content.style.maxHeight = content.scrollHeight + 'px';
        icon.textContent = '–'; // shows minus
      } else {
        content.style.maxHeight = null;
        icon.textContent = '+'; // reverts back to plus
      }
    });
  });
});